import Emitter from './Emitter'
import Socket from 'socket.io-client'

export default class{

    constructor(connection) {

        if(typeof connection == 'string'){
            this.Socket = Socket(connection);
        }else{
            this.Socket = connection
        }

        this.onEvent()

    }

    onEvent(){
        this.Socket.onevent = (packet) => {
            Emitter.emit(packet.data[0], packet.data[1])
        }

        let _this = this;

        ["connect", "error", "disconnect", "reconnect", "reconnect_attempt", "reconnecting", "reconnect_error", "reconnect_failed"]
            .forEach((value) => {
                _this.Socket.on(value, (data) => {
                    Emitter.emit(value, data)
                })
            })
    }

}


// WEBPACK FOOTER //
// ./src/ForkedModules/VueSocketIo/Observer.js